/**
 * Glyphe exiPlan — le signe de la marque, à la place du carré d'accent 8×8 (validé par Cédric
 * le 2026-09-28 ; @exidis/ui 1.6.0, coquille.md §1.1 point 2).
 *
 * C'est le glyphe du favicon (`public/favicon.svg` : quatre équerres aux coins, trois colonnes
 * de kanban de hauteurs différentes), REDESSINÉ sur une grille 20×20 et non le fichier du
 * favicon mis à l'échelle. Le favicon est dessiné en 32×32 avec un trait de 2 : réduit à 20 px,
 * son trait tomberait à 1,25 px et deviendrait flou. Ici, 1 unité = 1 px au rendu (emplacement
 * `BRAND_GLYPH`, `h-5 w-5`), axes des traits sur des coordonnées entières : le trait fait
 * réellement 2 px et tombe sur la grille de pixels.
 *
 * Correspondance avec le favicon (proportions conservées, arrondies au pixel) :
 * - équerres : branches de 3 (5 sur 32), cadre 2..18 (3..29 sur 32) ;
 * - colonnes : x = 6 / 10 / 14, départ commun y = 7, hauteurs 6 / 8 / 4 (10 / 14 / 6 sur 32) —
 *   la colonne du milieu reste la plus haute, celle de droite la plus courte.
 *
 * `stroke="currentColor"` : la couleur vient de `BRAND_GLYPH`, au trait `--accent-trait` depuis
 * @exidis/ui 1.7.0 (l'encre `#8a1d96` en clair, l'orchidée en sombre). Jamais la couleur du
 * favicon en dur — l'accent suit le token (et le thème sombre), il peut changer.
 * `aria-hidden` : le nom accessible est le libellé « exiPlan » qui suit le glyphe.
 */
export default function GlypheExiPlan({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      aria-hidden="true"
      focusable="false"
      className={className}
      data-glyphe="exiplan"
    >
      {/* Équerres aux quatre coins du cadre */}
      <path d="M2 5V2h3" />
      <path d="M15 2h3v3" />
      <path d="M18 15v3h-3" />
      <path d="M5 18H2v-3" />
      {/* Trois colonnes, hauteurs différentes (kanban) */}
      <path d="M6 7v6" />
      <path d="M10 7v8" />
      <path d="M14 7v4" />
    </svg>
  );
}
